import React from "react";
// import bg from '../assets/img/Illustrations/integrated_bg_2.png';
import setupIcon from '../assets/img/Icons/setup-icon.png'
import affordableCost from '../assets/img/Icons/affordable-cost.png'
import efficiancy from '../assets/img/Icons/efficiancy.png'
import productivity from '../assets/img/Icons/productivity.png'
import labill1 from './../assets/img/Illustrations/Integrated LIM-ELN home page pic .png';
// import lab from '../assets/img/adbs-1.png';
import { Nav } from 'react-bootstrap';
import { Link } from 'react-router-dom';



const IntegratedSolutions = () => {


    return (
        <div id="lims-eln" className="integration-main">
            <div className="inte-section-title">
                <h1>Smart Integrations for Smarter Labs</h1>
            </div>
            <div className="inte-lims-eln">
                <div className="int-title">
                    <h3>Integrated LIMS-ELN</h3>
                </div>
                <div className="int-content">
                    <div className="int-content-para" >
                        Enhance your lab’s efficiency with Lab Iconics LIMS-ELN. Automate workflows, streamline sample management, and accelerate report generation, enabling faster decision-making and increased productivity. Simplifies experiment documentation, enhances collaboration,
                        ensures data integrity, and accelerates research with secure, 
                        cloud-based accessibility. Streamlines quality processes, ensures compliance, enhances accountability, and drives continuous improvement with secure, cloud-based accessibility.
                    </div>
                    <div className="int-content-2">
                        <div className="int-content-points-div">
                            <div className=" tlims-features">
                            {/* keyicons inte-keyicons  */}
                                <div className='tlims-feature-card active inte-keyicons-items' style={{textAlign:'left',}}>
                                    {/* keyicons-items inte-keyicons-items  */}
                                    <div className="tlims-feature-icon">
                                        <div className="icon-placeholder keyicons-items-icon">
                                            <img src={setupIcon} alt="icon" />
                                        </div>
                                    </div>
                                    {/* <div><img src={setupIcon} alt="" className='keyicons-items-img'/></div> */}
                                    <div>Automated Backup System - Ensures critical data is backed up regularly to prevent loss or corruption</div> 
                                </div>
                                <div className='tlims-feature-card active inte-keyicons-items' style={{textAlign:'left'}}>
                                    {/* keyicons-items inte-keyicons-items  */}
                                    <div className="tlims-feature-icon">
                                        <div className="icon-placeholder keyicons-items-icon">
                                            <img src={affordableCost} alt="icon" />
                                        </div>
                                    </div>
                                    {/* <div><img src={affordableCost} alt="" className='keyicons-items-img' /></div> */}
                                    <div>Secure Data Protection -  Provides encryption, compression, and versioning for enhanced data security and integrity</div> 
                                </div>
                                <div className='tlims-feature-card active inte-keyicons-items' style={{textAlign:'left'}}>
                                    {/* keyicons-items inte-keyicons-items  */}
                                    <div className="tlims-feature-icon">
                                        <div className="icon-placeholder keyicons-items-icon">
                                            <img src={efficiancy} alt="icon" />
                                        </div>
                                    </div>
                                    {/* <div><img src={efficiancy} alt="" className='keyicons-items-img' /></div> */}
                                    <div>Disaster Recovery Ready - Allows seamless data restoration to different locations or virtual machines</div> 
                                </div>
                                <div className='tlims-feature-card active inte-keyicons-items' style={{textAlign:'left'}}>
                                    {/* keyicons-items inte-keyicons-items  */}
                                    <div className="tlims-feature-icon">
                                        <div className="icon-placeholder keyicons-items-icon">
                                            <img src={productivity} alt="icon" />
                                        </div>
                                    </div>
                                    {/* <div><img src={productivity} alt="" className='keyicons-items-img' /></div> */}
                                    <div>Flexible Scheduling - Automates backups at daily, weekly, or monthly intervals for continuous data protection</div>
                                </div>
                            </div> 
                            <div className='learn-more-div-eln' style={{position:'relative',zIndex:'20', padding:'0',}}>
                                <Nav.Link as={Link} to='/lims-eln' href='#lims-eln'>
                                    <div className='learn-more-btn' style={{backgroundColor:'#bfd6e1'}}>
                                        <span>Explore</span>
                                        <div className="arrow arrow--right">
                                            <span></span>
                                        </div>
                                    </div>
                                </Nav.Link>
                            </div>
                        </div>
                        <div className="sticky-feature-image-container img-two" style={{background:'none', zIndex :'10'}}>
                            <img src={labill1} alt="Content illustration" />
                        </div>
                    </div> 
                </div>
                
            </div>
            <div className="int-two-sections">
                <div className="inte-lims-qms" data-aos="fade-up" data-aos-delay="100">
                    <h3 data-aos="zoom-out">Integrated Solutions</h3>
                    <div>
                        <ul>
                            <li>Seamlessly manage samples, workflows, and experimental data in one place—bridging operational efficiency with scientific documentation.</li>
                            <li>Enhance quality control by integrating LIMS with QMS, enabling automated compliance checks, audit trails, and deviation handling.</li>
                            <li>Achieve real-time data acquisition from lab instruments directly into LIMS, minimizing manual entry and errors.</li>
                            <li>Consolidate lab operations, quality records, and instrument logs into a unified platform for better traceability and data integrity.</li>
                            <li>Integrated systems streamline regulatory documentation (21 CFR Part 11, ISO, GxP), while enabling automated SOPs and validation workflows.</li>
                            <li>Easily design experiments, capture raw data, and link it directly to test records and results within the same system.</li>
                            <li>End-to-end automation from test request creation to Certificate of Analysis (COA) release — all in one platform.</li>
                        </ul>
                    </div>
                    
                </div>
                <div className="inte-lims-instru"  data-aos="fade-up" data-aos-delay="100">
                    <h3 data-aos="zoom-out">Instrument Integration</h3>
                    <div>
                        <ul>
                            <li>Instrument Integration (RS232, TCP/IP, USB, File-based) - Connects with lab instruments using standard protocols to automate data capture into LIMS — ensuring accuracy and reducing manual work.</li>
                            <li> Real-Time Data Acquisition - Enables live data flow from instruments to LIMS, supporting time-sensitive testing and quick decision-making and reducing latency in critical lab workflows. </li>
                            <li>ERP Integration - Syncs with ERP systems for real-time updates on sample requests, inventory, batch numbers, and test results — enabling unified lab and business operations.</li>
                            <li>SAP HANA Integration (ODATA, BAPI, CDS Views) - Seamlessly integrates with SAP HANA using ODATA services, BAPI, and CDS views — ensuring fast, scalable, and secure data exchange between LIMS and SAP's in-memory database platform.</li>
                            <li>End-to-End Digital Traceability - Centralizes data from instruments and business systems into one platform, ensuring full traceability, compliance, and streamlined workflows.</li>
                        </ul>
                    </div>
                
                </div>
            </div>


        </div>
    )
}

export default IntegratedSolutions